export default function adjustGoToTopPosition() {
  const iframeSelector = '#embeddedMessagingFrame'
  const goTopSelector = '[data-testid="back-to-top-button"]'
  const OFFSET_ABOVE_CHAT = 16
  const DEBOUNCE_DELAY = 200

  let goTopBtn: HTMLElement | null = null
  let iframe: HTMLElement | null = null
  let debounceTimeout: number | null = null

  const getDeviceCategory = () => {
    const width = window.innerWidth
    if (width < 768) return 'mobile'
    if (width >= 768 && width <= 1024) return 'tabletOrLaptop'
    return 'desktop'
  }

  const elementsVisuallyOverlapOrAreTooClose = (r1: DOMRect, r2: DOMRect, threshold = 24): boolean => {
    const horizontallyClose =
      Math.max(0, Math.min(r1.right, r2.right) - Math.max(r1.left, r2.left)) > 0 ||
      Math.abs(r1.right - r2.left) <= threshold ||
      Math.abs(r2.right - r1.left) <= threshold

    const verticallyClose =
      Math.max(0, Math.min(r1.bottom, r2.bottom) - Math.max(r1.top, r2.top)) > 0 ||
      Math.abs(r1.bottom - r2.top) <= threshold ||
      Math.abs(r2.bottom - r1.top) <= threshold

    return horizontallyClose && verticallyClose
  }

  const resetGoTopStyles = () => {
    if (!goTopBtn) return
    goTopBtn.style.position = ''
    goTopBtn.style.bottom = ''
    goTopBtn.style.right = ''
    goTopBtn.style.zIndex = ''
  }

  const applyStyles = (category: string) => {
    if (!goTopBtn || !iframe) return

    resetGoTopStyles()

    const iframeRect = iframe.getBoundingClientRect()
    const goTopRect = goTopBtn.getBoundingClientRect()
    const isOverlapping = elementsVisuallyOverlapOrAreTooClose(iframeRect, goTopRect)

    const setOverlappingStyles = () => {
      if (goTopBtn) {
        goTopBtn.style.position = 'fixed'
        goTopBtn.style.bottom = `${iframeRect.height + OFFSET_ABOVE_CHAT}px`
        goTopBtn.style.right = '16px'
        goTopBtn.style.zIndex = '9999'
      }
    }

    if (category === 'mobile') {
      goTopBtn.style.position = 'fixed'
      goTopBtn.style.bottom = '25px'
      goTopBtn.style.right = '25px'
      goTopBtn.style.zIndex = '1000'
    } else if (category === 'tabletOrLaptop') {
      setOverlappingStyles()
    } else if (category === 'desktop') {
      if (isOverlapping) {
        setOverlappingStyles()
      } else {
        goTopBtn.style.position = 'unset'
      }
    }
  }

  const debouncedReposition = () => {
    if (debounceTimeout) clearTimeout(debounceTimeout)
    debounceTimeout = window.setTimeout(() => {
      const category = getDeviceCategory()
      applyStyles(category)
    }, DEBOUNCE_DELAY)
  }

  const tryInitialize = () => {
    iframe = document.querySelector(iframeSelector)
    goTopBtn = document.querySelector(goTopSelector)

    if (iframe && goTopBtn) {
      window.addEventListener('resize', debouncedReposition)
      window.addEventListener('scroll', debouncedReposition, { passive: true })
      debouncedReposition()
      return true
    }

    return false
  }

  if (!tryInitialize()) {
    const observer = new MutationObserver(() => {
      if (tryInitialize()) {
        observer.disconnect()
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }
}
